<template>
    <div class="body">
		<p  class="font1" style="padding-top: 8vh;">在追求知识的道路上，ESG课程引领我们关注全球责任。让我们共同践行，成就美好未来！</p>

		<div style="width: 90%;margin: 0 auto;margin-top: 2vh;">
			<p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 第一季度主题课程推荐：</p>
			<ul>
				<a @click="redirectToESG('解读碳中和-工程处25年3月专业课','https://iedu.foxconn.com/public/play/play?courseId=53951&companyId=728')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">解读碳中和-工程处25年3月专业课 </li></a>
				<a @click="redirectToESG('专题培训 ISO14064-3碳足迹核查','https://iedu.foxconn.com/public/play/play?courseId=49852&companyId=727')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">专题培训 ISO14064-3碳足迹核查</li></a>
				<a @click="redirectToESG('2024年认识生物多样性保护生物多样性专题知识培训','https://iedu.foxconn.com/public/play/play?courseId=48653&companyId=813')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">2024年认识生物多样性保护生物多样性专题知识培训</li></a>
				<a @click="redirectToESG('专题培训 CBAM欧洲碳边境机制','https://iedu.foxconn.com/public/play/play?courseId=48183&companyId=727')"  style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">专题培训 CBAM欧洲碳边境机制</li></a>
				<a @click="redirectToESG('Topic-Specific Training Carbon Footprinting (Scope 1, 2 & 3) and Science-based Targets','https://iedu.foxconn.com/public/play/play?courseId=44624&companyId=727')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">Topic-Specific Training Carbon Footprinting (Scope 1, 2 & 3) and Science-based Targets </li></a>
				<a @click="redirectToESG('Carbon Footprinting','https://iedu.foxconn.com/public/play/play?courseId=43057&companyId=727')" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">Carbon Footprinting</li></a>
			</ul>
		</div>
		<div style="width: 87%;margin: 0 auto;margin-top: 3vh;" v-if="coc">
			<p style="margin: 0 auto; font-size: 20px;color: #000;">必修课程完成情况：</p>
			<ul v-for="(item,index) in coc" :key="index" ref="">
				<a @click="redirectToESG(item.Name, item.link)" style="text-decoration: none;color: #000;">
					<li style="padding: 0;margin-top: 0;">{{ item.Name }}&nbsp;
						<span v-if="item.iscompleted" style="color: green;font-weight: 800;">已完成</span>
						<span v-else style="color: red;font-weight: 800;">未完成</span>
					</li>
				</a>
			</ul>
		</div>

    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data() {
		return {
			coc:[],
		}
    }, 
    methods: {
        redirectToESG(esgName,esgUrl) {
            var dataForm = {};
            dataForm.clickEsgName = esgName
            dataForm.clickEsgLink = esgUrl
            this.$emit('redirectToESG',dataForm);
        }
    },
    created(){
		if(this.ReportData.coc !== null){
			this.coc=JSON.parse(this.ReportData.coc)
            console.log(this.coc,'coc')
		}
    },
}
</script>
  
<style scoped>
.body {
	background: 
				url("../../assets/25March/logo.png") right  top  no-repeat,
				url("../../assets/25March/bg.jpg")  no-repeat;
	background-size: 100% 100%,cover;
	width: 100%;
	height: 100vh;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}

li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}

.font1 {
    width: 96%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #64892f;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font2 { 
    width: 96%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #64892f;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>